import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/fronteu/ampmworldfrontend/src/views/favorites/index.tsx");
